import React from 'react';

import { X } from 'react-feather';
import { css, StyleSheet } from 'aphrodite';
import theme from '~/src/theme';

import styles from './styles';
import { useSnackbar } from 'notistack';

const SuccessToast = React.forwardRef(({ onCancel, message, style }, ref) => {
  const customStyle = StyleSheet.create(style ? { style } : {});
  const { closeSnackbar } = useSnackbar();
  const handleClose = () => closeSnackbar();
  return (
    <div
      ref={ref}
      className={css(styles.toast, styles.successToast, customStyle.style)}
    >
      {message}
      <i className={css(styles.toastCloseIcon)}>
        <X
          size={16}
          color={theme.colors.white}
          onClick={onCancel ?? handleClose}
        />
      </i>
    </div>
  );
});

SuccessToast.defaultProps = {
  message: 'Success!',
};

export default SuccessToast;
